const en = {
  common: {
    loading: "Loading...",
    back: "Back",
    next: "Next",
    save: "Save",
    cancel: "Cancel",
    close: "Close",
    send: "Send",
    submit: "Submit",
    yes: "Yes",
    no: "No",
    error: "Error",
    success: "Success",
    search: "Search",
    more: "More",
    less: "Less",
    optional: "optional",
    required: "Required",
    perMonth: "/ month",
    oneTime: "one-time",
    free: "Free",
    skip: "Skip",
    pleaseWait: "Please wait...",
    backToHome: "Back to homepage",
    learnMore: "Learn more",
    email: "Email",
    phone: "Phone",
    password: "Password",
    name: "Name",
    selected: "selected",
    available: "available",
    used: "used",
    of: "of",
    question: "Question",
    craftBusiness: "Craft business",
    forCraftBusinesses: "For craft businesses",
    home: "Home",
    projectInquiry: "Project inquiry",
    projectInquiries: "Project inquiries",
  },
  header: {
    dashboard: "Dashboard",
    signOut: "Sign out",
    completeProfile: "Complete profile",
    submitInquiry: "Submit inquiry",
    signIn: "Sign in",
    menuOpen: "Open menu",
    menuClose: "Close menu",
    registerAsCraft: "Register as craft business",
  },
  footer: {
    tagline: "Qualified project inquiries.\nFor selected craft businesses.",
    motto: "Find · Connect · Build",
    platform: "Platform",
    findCraft: "Find a craft business",
    submitInquiry: "Submit project inquiry",
    forCraftBusinesses: "For craft businesses",
    aboutUs: "About us",
    legalAndContact: "Legal & Contact",
    imprint: "Imprint",
    privacy: "Privacy",
    accessibility: "Accessibility",
    contact: "Contact",
    copyright: "© {{year}} CRAFTFINDUS. For craft businesses in Germany, Austria and Switzerland.",
  },
  cookies: {
    title: "We use cookies",
    description: "We use cookies to provide you with the best possible experience on our website. More information in our",
    privacyLink: "Privacy Policy",
    acceptAll: "Accept all",
    configure: "Configure",
    saveSelection: "Save selection",
    onlyNecessary: "Only necessary",
    necessary: "Necessary",
    necessaryDesc: "Required for the operation of the website.",
    analytics: "Analytics",
    analyticsDesc: "Help us understand how the website is used.",
    marketing: "Marketing",
    marketingDesc: "Enable personalized advertising.",
  },
  mobileCta: {
    submitInquiry: "Submit inquiry",
    craftBusiness: "Craft business",
  },
  floatingPhone: {
    question: "Have questions? Give us a call:",
    ariaLabel: "Show phone number",
  },
  home: {
    seoTitle: "Find a craft business & receive project inquiries",
    seoDesc: "CRAFTFINDUS: Find the right craft business for free or receive qualified project inquiries as a craftsman. Intelligently matched, 3 to 5 businesses per project.",
    heroLabel: "The craft business platform for your project",
    heroTitle1: "Find the right",
    heroTitle2: "craftsman.",
    heroTitle3: "Without endless searching.",
    heroDesc: "Describe your project. We'll find 3 to 5 matching craft businesses for you. Free, in under 24 hours.",
    heroCta: "Find craftsmen for free",
    heroCtaCraft: "I'm a craft business",
    badge100Free: "100% free",
    badgeResponse: "Response in <24h",
    badgeVerified: "Verified craft businesses",
    tradesLabel: "Your project, our network",
    tradesTitle: "Find the right craftsman for every trade",
    tradesDesc: "Whether repair, new build or renovation – {{brand}} finds the right business near you.",
    tradesCta: "Find craftsmen for free now",
    electrician: "Electrician",
    electricianDesc: "Electrical installation, lighting, fuse boxes, smart home – find an electrician near you.",
    plumbing: "Plumbing & Heating",
    plumbingDesc: "Bathroom renovation, heating replacement, pipework – professional installers for your project.",
    roofing: "Roofers & Carpenters",
    roofingDesc: "Roof renovation, skylights, roof truss – experienced roofers for safe solutions.",
    painting: "Painters & Floor layers",
    paintingDesc: "Facade painting, wallpapering, flooring – creative craftsmen for beautiful spaces.",
    solar: "Solar & Climate",
    solarDesc: "Solar panels, heat pumps, air conditioning – sustainable energy solutions from specialists.",
    construction: "Construction & Interior",
    constructionDesc: "Drywall, tiling, complete renovation – everything from a single source.",
    howLabel: "3 simple steps",
    howTitle: "How to find the right craftsman",
    howDesc: "No endless searching. No endless phone calls. We guide you through the process.",
    step1Title: "Describe your project",
    step1Desc: "Answer a few simple questions – e.g. 'Renovate bathroom' or 'Install solar panels'.",
    step2Title: "Craftsmen are selected",
    step2Desc: "{{brand}} automatically finds up to 5 craft businesses that match your project through intelligent matching. From your region, with the right experience.",
    step3Title: "You get contacted",
    step3Desc: "The selected businesses contact you directly, personally, not by mass email. You decide who fits best.",
    benefitsLabel: "Benefits",
    benefitsTitle: "One platform, two winners",
    forClients: "For clients",
    clientsTitle: "Find craftsmen: easy & free",
    clientFree: "Completely free",
    clientFreeDesc: "No fees, no commission. You only pay your craftsman.",
    clientNoJargon: "No jargon needed",
    clientNoJargonDesc: "Describe your project in your own words. We find the right trades.",
    clientFast: "Fast responses",
    clientFastDesc: "Within 24 hours, 3 to 5 matching craft businesses will contact you.",
    clientQuality: "Verified quality",
    clientQualityDesc: "All businesses are verified. Master craftsmen are highlighted.",
    clientCta: "Submit free inquiry",
    forProviders: "For craft businesses",
    providersTitle: "Qualified project inquiries, effortlessly",
    providerMatched: "Matching projects",
    providerMatchedDesc: "Only inquiries that match your trade, region and capacity.",
    providerCompetitors: "Max. 3 to 5 competitors",
    providerCompetitorsDesc: "No mass platform. Fair chances through intelligent limitation.",
    providerTransparent: "Transparent costs",
    providerTransparentDesc: "A fixed price per project inquiry. No monthly fees, no commissions.",
    providerRate: "High acceptance rate",
    providerRateDesc: "Because the matching works: high quality, little waste.",
    providerCta: "Register as craft business",
    principlesTitle: "Why {{brand}}?",
    principle1Num: "01",
    principle1Title: "No searching, no comparing",
    principle1Desc: "We don't show endless lists. Our algorithm selects the right businesses for you – based on data, not chance.",
    principle2Num: "02",
    principle2Title: "Quality over quantity",
    principle2Desc: "Maximum 3 to 5 craft businesses per project. So you get real attention, not copy-paste offers.",
    principle3Num: "03",
    principle3Title: "Transparent & fair",
    principle3Desc: "Everyone knows why a match was made. No bidding, no price dumping. Fair conditions for both sides.",
    statsTitle: "{{brand}} in numbers",
    stat1Value: "3-5",
    stat1Label: "Businesses per project",
    stat2Value: "12+",
    stat2Label: "Trades available",
    stat3Value: "<24h",
    stat3Label: "Response time",
    stat4Value: "€0",
    stat4Label: "Cost for clients",
    faqLabel: "FAQ",
    faqTitle: "Frequently asked questions",
    faqDesc: "Answers for clients and craft businesses.",
    faqForClients: "For clients",
    faqForProviders: "For craft businesses",
    faqC1Q: "I need a craftsman but don't know exactly which trade. Is CRAFTFINDUS right for me?",
    faqC1A: "Yes, absolutely! CRAFTFINDUS is made for exactly that. Simply describe your project in the guided inquiry – we'll find the right trade and the best businesses for you. Completely free.",
    faqC2Q: "What does it cost to find a craftsman?",
    faqC2A: "For you as a client, CRAFTFINDUS is completely free. You submit your project inquiry, receive 3 to 5 matching craft businesses, and decide yourself who to work with. No hidden costs.",
    faqC3Q: "How quickly will I get responses to my project inquiry?",
    faqC3A: "Typically, qualified craft businesses will contact you within 24 hours. For urgent inquiries, often even faster. You receive a maximum of 3 to 5 proposals – hand-picked, not mass responses.",
    faqC4Q: "What types of projects can I submit through CRAFTFINDUS?",
    faqC4A: "Practically all craft projects: electrical installation, plumbing, heating, roofing, interior finishing, photovoltaics, air conditioning, painting, and much more. Whether a small repair or a large construction project.",
    faqP1Q: "What does CRAFTFINDUS offer me as a craft business?",
    faqP1A: "You receive pre-qualified project inquiries that match your trade and region. A maximum of 3 to 5 businesses per inquiry means: less competition, higher closing rates, no price wars.",
    faqP2Q: "How does matching work at CRAFTFINDUS?",
    faqP2A: "Our algorithm analyzes each project inquiry and matches it with your profile: trade, specialization, region, availability, and project size. You only receive inquiries with a high match.",
    faqP3Q: "What does CRAFTFINDUS cost for craft businesses?",
    faqP3A: "You only pay a transparent, fixed price per accepted project inquiry. No monthly fees, no commissions on your orders. You decide which projects to accept.",
    faqP4Q: "What sets CRAFTFINDUS apart from other craft portals?",
    faqP4A: "No bidding, no price dumping, no comparison portal mechanics. At CRAFTFINDUS, craft businesses are selected, not searched for. The limit of 3 to 5 businesses per inquiry ensures fair opportunities.",
    ctaLabel: "Get started",
    ctaTitle: "What applies to you?",
    ctaClientTitle: "I'm looking for a craftsman",
    ctaClientDesc: "Describe your project. We'll find the right craft businesses for you, free of charge.",
    ctaClientBtn: "Submit free inquiry",
    ctaProviderTitle: "I'm a craft business",
    ctaProviderDesc: "Receive pre-qualified project inquiries that match your profile. No bidding, no price wars.",
    ctaProviderBtn: "Register now",
    socialProof: "Over 500 projects successfully matched — 97% recommendation rate",
    proofVerified: "Verified businesses",
    proofDsgvo: "GDPR compliant",
    proofResponse: "Avg. 4h response time",
  },
  auth: {
    seoTitle: "Sign in – Craft business portal",
    seoDesc: "Sign in to CRAFTFINDUS – the exclusive portal for qualified craft businesses.",
    backToHome: "Back to homepage",
    loginPrompt: "Sign in to your account",
    emailLabel: "Email",
    emailPlaceholder: "your@email.com",
    passwordLabel: "Password",
    passwordPlaceholder: "••••••••",
    loginBtn: "Sign in",
    invalidCredentials: "Invalid credentials. Please check your input.",
    alreadyRegistered: "This email address is already registered.",
    registrationSuccess: "Registration successful! Please confirm your email.",
    loginSuccess: "Successfully signed in",
    invalidEmail: "Please enter a valid email address",
    passwordMin: "Password must be at least 6 characters",
  },
  dashboard: {
    title: "Project inquiries",
    subtitle: "Qualified project inquiries for your business",
    tabNew: "New",
    tabInReview: "In review",
    tabCompleted: "Completed",
    tabPayment: "Payment & Billing",
    tabProfile: "Profile",
    noNew: "No new project inquiries",
    noInReview: "No ongoing project inquiries",
    noCompleted: "No completed project inquiries",
    selectForDetails: "Select a project inquiry\nfor details",
    weeklyLimitReached: "Weekly limit reached",
    paymentMissing: "Payment method missing",
    paymentMissingDesc: "Project inquiries will only be activated after payment setup.",
    setupPayment: "Set up now →",
    paymentRequired: "Please set up a payment method first",
    subscriptionBlocked: "Subscription blocked – please complete payment under billing",
    quotaExhausted: "Quota reached – buy an add-on or upgrade your plan",
    acceptError: "Error accepting",
    accepted: "Project inquiry accepted",
    declined: "Project inquiry declined",
    declineError: "Error declining",
    questionSent: "Follow-up question sent",
    completed: "Project inquiry completed",
    completeError: "Error completing",
  },
  onboarding: {
    progressCompany: "Business",
    progressTradesRegion: "Trades & Region",
    progressConfig: "Configuration",
    companyTitle: "Your business",
    companySubtitle: "Basic information for your profile",
    companyName: "Business name",
    companyNamePlaceholder: "Your craft business",
    contactPerson: "Contact person",
    contactPersonPlaceholder: "John Smith",
    masterCraftsman: "Master craftsman",
    masterCraftsmanDesc: "Your business is a registered master craft business",
    tradesTitle: "Your trades",
    tradesSubtitle: "Which trades do you cover?",
    regionTitle: "Your location",
    regionSubtitle: "Where is your business located?",
    regionLabel: "Region / Postal code",
    regionPlaceholder: "e.g. Munich, 80331",
    radiusTitle: "Service radius",
    radiusSubtitle: "How far do you travel to customers?",
    limitTitle: "Project inquiry limit",
    limitSubtitle: "How many inquiries do you want per week?",
    limitFocused: "Focused",
    limitStandard: "Standard",
    limitIntensive: "Intensive",
    completeTitle: "Save business profile",
    summaryCompany: "Business",
    summaryTrades: "Trades",
    summaryMaster: "Master craftsman",
    summaryRadius: "Service radius",
    summaryLimit: "Limit",
    summaryPerWeek: "per week",
    saveProfile: "Save business profile",
    saving: "Saving...",
    profileCreated: "Business profile created",
    saveError: "Error saving",
    veryNear: "Very near",
    nearCity: "Near city",
    regional: "Regional",
    wide: "Wide area",
    superRegional: "Super-regional",
  },
  inquiry: {
    seoTitle: "Submit project inquiry – Find qualified craft businesses",
    seoDesc: "Submit a project inquiry at CRAFTFINDUS: Describe your project and we'll find up to 5 qualified craft businesses from your region.",
    tradeElektriker: "Electrician",
    tradeSanitaer: "Plumbing",
    tradeHeizung: "Heating",
    tradeDachdecker: "Roofer",
    tradeInnenausbau: "Interior finishing",
    tradeSchreiner: "Carpenter",
    tradeBauunternehmen: "Construction company",
    tradeFensterbauer: "Window installer",
    tradeGartenbau: "Landscaping",
    tradePhotovoltaik: "Photovoltaics",
    tradeKlimaanlagen: "Air conditioning",
    tradeMalerbetrieb: "Painter",
    progressDetails: "Project details",
    progressDescription: "Description",
    progressContact: "Contact",
    questionOf: "Question {{current}} of {{total}}",
    tradeTitle: "Which trade do you need?",
    tradeSubtitle: "Select the appropriate trade",
    tradesLoading: "Loading trades...",
    projectTypeTitle: "Type of project",
    projectTypeSubtitle: "What needs to be done?",
    repair: "Repair",
    repairDesc: "Fix existing damage",
    newBuild: "New build",
    newBuildDesc: "New building or extension",
    renovation: "Renovation",
    renovationDesc: "Renovate existing",
    installation: "Installation",
    installationDesc: "Install new system or equipment",
    objectTypeTitle: "Type of property",
    objectTypeSubtitle: "What type of building?",
    efh: "Detached house",
    mfh: "Multi-family house",
    commercial: "Commercial / Office",
    industrial: "Industrial",
    publicBuilding: "Public building",
    urgencyTitle: "How urgent is your project?",
    urgencySubtitle: "Timeframe for start",
    immediate: "Immediately",
    immediateDesc: "As soon as possible",
    oneWeek: "1 week",
    oneWeekDesc: "Within the next 7 days",
    oneMonth: "1 month",
    oneMonthDesc: "Within the next 30 days",
    flexible: "Flexible",
    flexibleDesc: "No fixed timeframe",
    budgetTitle: "Estimated budget",
    budgetSubtitle: "Helps with matching",
    under2k: "Under €2,000",
    budget2k10k: "€2,000 to €10,000",
    budget10k50k: "€10,000 to €50,000",
    over50k: "Over €50,000",
    budgetUnclear: "Not sure yet",
    descriptionTitle: "Describe your project",
    descriptionSubtitle: "Max. 5,000 characters",
    descriptionPlaceholder: "What needs to be done? Any special requirements?",
    desiredStart: "Desired start date (optional)",
    locationTitle: "Where is the project located?",
    locationSubtitle: "Enter postal code or city",
    contactTitle: "Company & Contact Details",
    contactSubtitle: "For contact by qualified craft businesses",
    companyInfoTitle: "Company Information",
    companyNameLabel: "Company Name",
    companyNamePlaceholder: "Your company name",
    companyPostalCode: "Postal Code",
    companyCity: "City",
    companyCityPlaceholder: "e.g. Berlin",
    companyStreet: "Street",
    companyStreetPlaceholder: "e.g. Main Street 1",
    companyPhoneLabel: "Phone (Central)",
    companyEmailLabel: "Email (Central)",
    companyNote: "Note",
    companyNotePlaceholder: "Additional notes about the company...",
    contactPersonTitle: "Contact Person",
    contactNameLabel: "Name",
    contactNamePlaceholder: "Your name",
    contactEmailLabel: "Email",
    contactPhoneLabel: "Phone",
    contactPhonePlaceholder: "+49 ...",
    contactMobile: "Mobile",
    postalCodePlaceholder: "e.g. 42275",
    phonePlaceholder: "+49 ...",
    emailPlaceholder: "info@company.com",
    contactEmailPlaceholder: "name@company.com",
    mobilePlaceholder: "+49 170 ...",
    contactPositionLabel: "Position",
    contactPositionPlaceholder: "e.g. Managing Director",
    addContact: "Add another contact (optional)",
    additionalContact: "Additional Contact",
    toSummary: "Continue to summary",
    commitTitle: "Submit to up to 5 qualified craft businesses",
    commitDesc: "Your inquiry will be forwarded directly to matching businesses in your region.",
    summaryTrade: "Trade",
    summaryProjectType: "Project type",
    summaryUrgency: "Urgency",
    summaryLocation: "Location",
    summaryBudget: "Budget",
    submitInquiry: "Submit project inquiry",
    submitting: "Submitting...",
    submitSuccess: "Project inquiry successfully submitted",
    submitError: "Error sending inquiry",
  },
  thankyou: {
    inquiryTitle: "Your project inquiry has been received",
    inquiryDesc: "We are now matching your project with our network of qualified craft businesses.",
    nextStepsTitle: "What happens next",
    inquiryStep1: "We review your inquiry and find up to 5 matching craft businesses.",
    inquiryStep2: "You'll receive contact suggestions via email – usually within 24 hours.",
    inquiryStep3: "You freely decide which business to talk to.",
    urgentContact: "For urgent questions, reach us at",
    registrationTitle: "Registration received!",
    registrationDesc: "Thank you for your interest in CRAFTFINDUS. We have received your registration.",
    registrationStep1: "Our team carefully reviews your information.",
    registrationStep2: "After successful review, you'll receive your login credentials by email.",
    registrationStep3: "You can then sign in and immediately receive qualified project inquiries.",
    reviewTime: "Review usually takes 1–2 business days.",
    contactTitle: "Thank you for your message",
    contactDesc: "We have received your inquiry and will get back to you as soon as possible.",
    contactResponse: "We usually respond within 24 hours on business days. For urgent matters, you can also reach us by phone at",
    sendAnother: "Send another message",
  },
  contact: {
    seoTitle: "Contact – Reach CRAFTFINDUS",
    seoDesc: "Contact CRAFTFINDUS: Questions about project inquiries, registration or partnership?",
    title: "Contact",
    desc: "Do you have questions about {{brand}} or want to reach us directly? We look forward to your message.",
    phoneLabel: "Phone",
    emailLabel: "Email",
    nameLabel: "Name *",
    namePlaceholder: "Your name",
    emailFieldLabel: "Email *",
    emailPlaceholder: "your@email.com",
    subjectLabel: "Subject *",
    subjectPlaceholder: "What is it about?",
    messageLabel: "Message *",
    messagePlaceholder: "Your message to us...",
    sendBtn: "Send message",
    sending: "Sending...",
    sent: "Message sent!",
    sendFailed: "Sending failed. Please try again later.",
    nameRequired: "Please enter your name",
    emailRequired: "Please enter a valid email address",
    subjectRequired: "Please enter a subject",
    messageMin: "Message must be at least 10 characters long",
  },
  about: {
    seoTitle: "About CRAFTFINDUS – Fair & intelligent craft matching",
    seoDesc: "CRAFTFINDUS connects clients with qualified craft businesses in the DACH region.",
    heroLabel: "About {{brand}}",
    heroTitle1: "The people behind",
    heroTitle2: "CRAFTFINDUS.",
    heroDesc: "{{brand}} was born from a simple observation: Clients struggle to find the right craft business. And good craftsmen spend too much time on acquisition instead of doing what they do best.",
    teamLabel: "Our team",
    teamTitle: "The people behind",
    founderRole: "Founder",
    founderBio1: "As an entrepreneur from Solingen, I know both sides: The frustration of clients who don't know which business to turn to. And the challenge for craft businesses to continuously get qualified inquiries.",
    founderBio2: "{{brand}} is my answer to this problem. A platform that doesn't rely on mass distribution, but on intelligent, fair matching. Where quality counts, not the lowest price.",
    chrisRole: "Business partner",
    chrisBio: "Chris brings strategic thinking and entrepreneurial experience to the team. As a business partner, he drives the development of {{brand}} forward and ensures our vision becomes reality.",
    veronikaRole: "Executive Assistant & Back Office",
    veronikaBio: "Veronika holds all the threads together behind the scenes. As executive assistant and back office manager, she ensures processes run smoothly and the team can focus on what matters.",
    dukeRole: "Office dog & Feel-Good Manager",
    dukeBio: "No meeting without Duke. Our Bull Terrier brings good vibes, reminds us to take breaks and is an integral part of the team. If you call us, you might hear him in the background.",
    valuesLabel: "Our values",
    valuesTitle: "What we stand for",
    value1Title: "Quality over quantity",
    value1Desc: "We believe in fewer, but better connections. That's why we limit every inquiry to 3 to 5 businesses. No mass distribution, no price wars.",
    value2Title: "Fairness for both sides",
    value2Desc: "Free for clients, transparent fixed prices for craft businesses. No hidden fees, no commissions on orders.",
    value3Title: "Simplicity",
    value3Desc: "Craftsmanship is complex enough. We translate the need into the right language and make the path to the right business as easy as possible.",
    missionLabel: "Our mission",
    missionTitle: "Craft matching, as it should be",
    missionP1: "The craft market is fragmented. Thousands of businesses, countless portals, but hardly any real orientation. Clients compare apples with oranges. Craft businesses fight for visibility on overcrowded platforms.",
    missionP2: "{{brand}} does it differently: We specifically select 3 to 5 matching businesses for each inquiry. No bidding, no price dumping. Instead, transparent scores, fair prices and real connections.",
    missionP3: "Our goal: The first point of contact in the DACH region for clients looking for a craft business. And the preferred source for craftsmen who want to grow predictably.",
    ctaTitle: "Ready to get to know us?",
    ctaDesc: "Whether you're looking for a craft business or want to receive qualified project inquiries as a craftsman: We look forward to hearing from you.",
    ctaInquiry: "Submit project inquiry",
    ctaContact: "Get in touch",
  },
  pricing: {
    seoTitle: "Pricing – Subscription plans for craft businesses",
    seoDesc: "Transparent monthly plans for qualified project inquiries. Basic from €49, Pro from €129, Premium from €249.",
    heroLabel: "Pricing",
    heroTitle1: "More orders.",
    heroTitle2: "Less downtime.",
    heroDesc: "Choose the plan that fits your business. All plans include qualified, pre-verified project inquiries – delivered directly to your dashboard.",
    leadsIncluded: "accepted leads included",
    choosePlan: "Choose plan",
    mostPopular: "Most popular plan",
    addonsLabel: "Add-ons",
    addonsTitle: "Book additional leads",
    radiusLabel: "Radius expansions",
    radiusTitle: "Expand your service area",
    radiusDesc: "Expand your service radius and receive project inquiries from a larger area.",
    trustNoContract: "No contract commitment",
    trustInstant: "Instantly ready",
    trustVerified: "Only verified inquiries",
    landingLabel: "Pricing for craft businesses",
    landingTitle: "Transparent subscription plans",
    landingDesc: "Choose the plan that fits your business – no hidden costs, no contract commitment.",
    landingCta: "View all plans",
    faqLabel: "Common questions",
    faqTitle: "Questions about pricing",
    ctaTitle: "Ready for new orders?",
    ctaDesc: "Register for free, choose your plan and receive matching project inquiries.",
    ctaBtn: "Register now",
    faq1q: "Do I only pay on acceptance?",
    faq1a: "No – with a subscription plan you pay a fixed monthly amount that includes a certain number of accepted leads. You know exactly what you pay. Additional leads can be booked as add-ons.",
    faq2q: "What happens when I use up my quota?",
    faq2a: "When your included leads are used up, you can buy an add-on (+10 or +25 leads). Without an add-on, no further leads will be available for acceptance.",
    faq3q: "Can I change plans at any time?",
    faq3a: "Yes, you can upgrade at any time. The new plan takes effect immediately. For a downgrade, the current billing period runs to completion.",
    faq4q: "Is there a contract commitment?",
    faq4a: "No. You can cancel your subscription at any time at the end of the current period. No minimum term.",
    faq5q: "What's special about the 'Premium' plan?",
    faq5a: "Premium businesses receive a Verified badge, are prioritized in delivery and have a personal contact person.",
  },
  billing: {
    title: "Billing & Plan",
    subtitle: "Manage your plan, quotas and payment method",
    tabPlan: "Plan & Billing",
    tabQuotas: "Quotas",
    tabPayment: "Payment method",
    statusActive: "Active",
    statusTrial: "Trial",
    statusPastDue: "Payment overdue",
    statusBlocked: "Blocked",
    statusCanceled: "Cancelled",
    statusPending: "Pending",
    pastDueBanner: "Payment failed. Please update your payment method.",
    blockedBanner: "Subscription blocked. Please complete payment to continue.",
    updatePayment: "Update payment method",
    cancelledNotice: "Your subscription ends on {{date}}.",
    cancelSub: "Cancel subscription",
    cancelConfirm: "Do you really want to cancel your subscription at period end?",
    cancelSuccess: "Subscription will be cancelled at period end",
    noPlan: "No active plan",
    noPlanDesc: "Choose a plan to receive qualified project inquiries.",
    changePlan: "Change plan",
    selectPlan: "Choose plan",
    currentPlan: "Current",
    activePlan: "Active plan",
    leadsIncl: "Leads incl.",
    addonsTitle: "Add-ons",
    buy: "Buy",
    acceptedLeads: "Accepted leads",
    deliveries: "Deliveries",
    quotaReached: "Quota reached – buy an add-on or upgrade your plan",
    billingPeriod: "Billing period",
    periodResets: "Quotas are automatically reset at the start of each period.",
  },
  invoices: {
    title: "Invoice Overview",
    subtitle: "All payments and invoices at a glance",
    empty: "No invoices yet",
    emptyDesc: "Once payments are made, they will appear here.",
    colDate: "Date",
    colDescription: "Description",
    colAmount: "Amount",
    colStatus: "Status",
    colMethod: "Method",
    download: "Download receipt",
    statusPaid: "Paid",
    statusOpen: "Open",
    statusPending: "Pending",
    statusCanceled: "Canceled",
    statusExpired: "Expired",
    statusFailed: "Failed",
  },
  registration: {
    seoTitle: "Register craft business – Receive qualified project inquiries",
    seoDesc: "Register as a craft business at CRAFTFINDUS: Ready in 15 minutes.",
    title: "Register as craft business",
    subtitle: "Fill out the form. After review, you'll receive your login credentials by email.",
    requiredFields: "Required fields: Business name, contact person, email",
    fillRequired: "Please fill in business name, contact person and email.",
    submitting: "Submitting...",
    submitBtn: "Submit registration",
    submitError: "Error submitting",
  },
  handwerker: {
    seoTitle: "Win customers – Qualified project inquiries without cold calling",
    seoDesc: "Win customers without cold calling: CRAFTFINDUS delivers pre-qualified project inquiries matching your trade & region.",
    heroLabel: "For craft businesses & master craftsmen",
    heroTitle1: "Qualified project inquiries.",
    heroTitle2: "No price wars.",
    heroDesc: "{{brand}} delivers pre-qualified project inquiries from customers who need a craftsman right now. Precisely matched to your trade, limited to 3 to 5 businesses per project.",
    registerFree: "Register for free now",
    badgeNoContract: "No contract commitment",
    badgeReady: "Ready in 15 min",
    badgeVerified: "Only verified inquiries",
    badgePayOnAccept: "Payment only on accepted project",
    benefitsLabel: "Your benefits",
    benefitsTitle: "Why craft businesses choose {{brand}}",
    benefit1Title: "Precisely matched",
    benefit1Desc: "Our algorithm matches every inquiry with your profile: trade, region, capacity. You only receive projects that truly fit.",
    benefit2Title: "Max. 3 to 5 businesses per project",
    benefit2Desc: "No mass distribution. Each inquiry goes to few, selected craft businesses. Less competition, higher closing rates.",
    benefit3Title: "Transparent fixed prices",
    benefit3Desc: "You only pay per accepted inquiry – a fixed, transparent price. No monthly fees, no commissions.",
    benefit4Title: "Pre-qualified inquiries",
    benefit4Desc: "Every project inquiry is reviewed before being forwarded to you. No spam, no fantasy requests – only real projects.",
    benefit5Title: "Predictable growth",
    benefit5Desc: "Flexibly determine how many inquiries you accept per month – and control your workload.",
    benefit6Title: "Quick access",
    benefit6Desc: "Register, create profile, receive first inquiries. Ready in under 15 minutes.",
    pricingLabel: "Pricing examples",
    pricingTitle: "Transparent fixed prices per project inquiry",
    pricingDesc: "You only pay for inquiries you actively accept. The price depends on project category and size.",
    smallProjects: "Small projects",
    smallExamples: "e.g. installing outlets, fixing taps, painting walls, changing locks",
    mediumProjects: "Medium & large projects",
    mediumExamples: "e.g. bathroom renovation, heating replacement, solar system, roof renovation, complete renovation",
    priceFrom: "from €{{price}}",
    perAcceptedInquiry: "per accepted project inquiry",
    goodToKnow: "Good to know",
    goodToKnow1: "No monthly fees. You only pay on acceptance",
    goodToKnow2: "Project size determines the price – transparently visible beforehand",
    goodToKnow3: "Complaint on misqualification – refund guaranteed",
    goodToKnow4: "Billing via your stored payment method",
    howLabel: "How it works",
    howTitle: "3 steps to new projects",
    step1Title: "Create profile",
    step1Desc: "Specify trade, region, capacity and specialization.",
    step2Title: "Receive project inquiries",
    step2Desc: "Matching projects are automatically delivered to you.",
    step3Title: "Accept & contact",
    step3Desc: "You decide which projects to accept and speak directly with the customer.",
    startNow: "Start now",
    faqLabel: "Common questions",
    faqTitle: "Questions from craft businesses",
    ctaTitle: "Ready for qualified project inquiries?",
    ctaDesc: "Register for free, create your profile and receive matching projects – no contract commitment.",
    ctaBtn: "Register for free",
  },
  notFound: {
    title: "Page not found",
    description: "The requested page does not exist.",
  },
  limitReached: {
    title: "Pause",
    subtitle: "Your weekly limit has been reached.",
    nextReset: "Next unlock",
    description: "The limit protects the quality of the platform and ensures that every inquiry receives full attention.",
    adjustLimit: "Adjust limit",
  },
  skipLink: "Skip to main content",
  portal: {
    switchPortal: "Switch portal",
    profile: "Profile",
    changePassword: "Change password",
    signOut: "Sign out",
    newPassword: "New password",
    passwordPlaceholder: "At least 6 characters",
    saving: "Saving...",
    saveBtn: "Save",
    cancelBtn: "Cancel",
  },
  opportunityDetail: {
    company: "Company",
    confidentialUntilAccept: "Confidential until acceptance",
    notSpecified: "Not specified",
    urgency: "Urgency",
    decision: "Decision",
    matchScore: "Match score",
    location: "Location",
    remote: "Remote",
    remotePossible: "Possible",
    onsite: "On-site",
    compliance: "Compliance",
    complianceRelevant: "Relevant",
    onsiteLabel: "On-site",
    onsiteRequired: "Required",
    context: "Context",
    whySelected: "Why you were selected",
    inquiryAccess: "Inquiry access",
    accepting: "Accepting...",
    acceptInquiry: "Accept inquiry",
    decline: "Decline",
    responseWindow: "Response window: 2h recommended",
    claimLabel: "Claim",
    claimBtn: "File claim",
    completed: "Completed",
    won: "Won",
    lost: "Lost",
    noFit: "No fit",
    claimApproved: "Approved",
    claimRejected: "Rejected",
    claimUnderReview: "Under review",
    claimSubmitted: "Submitted",
    submittedAt: "Submitted on",
    decidedAt: "Decided on",
    reason: "Reason",
    rejectionReason: "Rejection reason",
    note: "Note",
    expiresIn: "Expires in {{hours}}h",
    expired: "Expired",
  },
  regForm: {
    companyData: "Business data",
    companyName: "Business name *",
    companyNamePlaceholder: "Your craft business",
    companyType: "Company type",
    companyTypePlaceholder: "– Please select –",
    legalName: "Legal name",
    legalNamePlaceholder: "e.g. per trade register",
    contactPerson: "Contact person *",
    contactPersonPlaceholder: "Your name",
    role: "Role / Position",
    rolePlaceholder: "e.g. Master craftsman, CEO",
    email: "Email *",
    emailPlaceholder: "your@email.com",
    phone: "Phone",
    phonePlaceholder: "+49 ...",
    website: "Website",
    websitePlaceholder: "https://...",
    invoiceEmail: "Invoice email",
    invoiceEmailPlaceholder: "accounting@business.com",
    address: "Address",
    street: "Street & number",
    postalCode: "Postal code",
    city: "City",
    country: "Country",
    countryDE: "Germany",
    countryAT: "Austria",
    countryCH: "Switzerland",
    vatId: "VAT ID",
    vatIdPlaceholder: "DE123456789",
    contacts: "Contact persons",
    contactsDesc: "Optional: Additional contact persons in your company",
    addContact: "Add contact",
    noContacts: "No additional contact persons yet",
    createContact: "Create contact",
    contactN: "Contact {{n}}",
    primaryContact: "Primary contact",
    setPrimary: "Set as primary",
    nameRequired: "Name *",
    emailRequired: "Email *",
    rolePlaceholderShort: "e.g. Sales",
  },
  stackPicker: {
    noResults: "No technology found",
    addCustom: "Add custom technology",
    customPlaceholder: "e.g. SAP, DATEV, Lexware...",
  },
  opService: {
    regionsTitle: "Regions & Service Area",
    mainRegion: "Main region",
    pleaseSelect: "Please select",
    serviceRegions: "Service regions (multi-select)",
    serviceLocations: "Service locations with radius",
    serviceLocationsDesc: "Define specific locations with service radius",
    addLocation: "Location",
    noLocations: "Optional: Service locations with radius for more precise matching",
    locationN: "Location {{n}}",
    locationCity: "City / Place *",
    locationCityPlaceholder: "e.g. Munich",
    locationPostal: "Postal code",
    locationPostalPlaceholder: "e.g. 80331",
    locationRadius: "Radius (km)",
    remoteSupport: "Remote support available",
    serviceCategories: "Service categories",
    expertiseTitle: "Expertise & Specializations",
    tagsLoading: "Loading tags...",
    slaTitle: "SLA & Quotas",
    slaTier: "SLA Tier",
    sla2h: "2 Hours",
    sla4h: "4 Hours",
    slaNBD: "Next Business Day",
    slaResponseTime: "SLA Response Time (h)",
    weeklyLimit: "Weekly limit",
    monthlyLimit: "Monthly limit",
    qualityTitle: "Quality Metrics (Initial)",
    qualityDesc: "Starting values for new providers. Adjusted automatically.",
    qualityScore: "Quality Score",
    qualityScoreRange: "0.00 – 1.00",
    acceptanceRate: "Acceptance rate",
    avgResponseTime: "Avg. Response Time (h)",
  },
  // (avatarPicker keys moved to bottom of file)
  salesBenchmarks: {
    costPerLead: "Cost per qualified lead",
    conversionFirstMeeting: "Conversion Lead → First meeting",
    conversionCustomer: "Conversion Lead → Customer",
    cac: "Customer Acquisition Cost",
  },
  thankyouExtra: {
    orVia: "or via",
    emailLabel: "Email",
  },
  pdExtra: {
    slaResponseTime: "SLA Response Time",
  },
  completionDialog: {
    confirmTitle: "Complete inquiry",
    confirmDesc: "Is the inquiry completed and contact with the customer ended?",
    confirmYes: "Yes, complete",
    confirmNo: "No, go back",
    outcomeTitle: "Result",
    outcomeDesc: "Was an order placed?",
    won: "Yes – Order won",
    lost: "No – Order lost",
    noFit: "No fit / Not pursued",
  },
  suche: {
    seoTitle: "Find a craft business – free & without registration",
    seoDesc: "Find matching craft businesses: free, non-binding & GDPR-compliant. Describe your project – up to 5 verified craftsmen from your region respond within 24h.",
    trustDach: "🇩🇪 🇦🇹 🇨🇭 DACH-wide",
    trustFree: "100% free",
    trustGdpr: "GDPR-compliant",
    trustConsent: "No sharing without consent",
    heroTitle: "Find the right craft business.",
    heroAccent: "Free, non-binding & without registration",
    heroDesc: "We find matching craft businesses from your region through intelligent matching. You receive up to 5 offers from qualified businesses. You choose who best fits your project.",
    heroCta: "Find a craft business now",
    heroSubline: "Free · Non-binding · Response within 24h",
    howBtn: "How does {{brand}} work?",
    howTitle: "How does {{brand}} work?",
    howIntro: "{{brand}} connects clients with qualified craft businesses in the DACH region. Here's how it works:",
    howStep1: "You describe your project",
    howStep1Desc: "in a few steps, no technical jargon needed.",
    howStep2: "Intelligent matching",
    howStep2Desc: "our algorithm finds matching businesses from your region.",
    howStep3: "Human validation",
    howStep3Desc: "every match is reviewed before it goes out.",
    howStep4: "Up to 5 businesses contact you",
    howStep4Desc: "personally and directly.",
    howFreeTitle: "Completely free for you",
    howFreeDesc: "The costs are covered by the craft business. For you as a client, the service is 100% free and non-binding.",
    problemsTitle: "You know the",
    problemsAccent: "problem",
    problemsSuffix: ". We find the solution",
    problemsDesc: "No expertise needed. Simply describe what needs to be done.",
    problem1: "Heating broken or plumbing needed",
    problem2: "Electrical installation or solar system planned",
    problem3: "Roof repair or re-roofing",
    problem4: "Interior work, drywall or painting",
    problem5: "Windows, doors or facade renewal",
    problem6: "Garden or landscaping work",
    problemsCta: "Describe your project now",
    problemsCtaSub: "No expertise required · Guided process",
    stepsTitle: "3 steps to the",
    stepsAccent: "right craftsman",
    stepsDesc: "This is how {{brand}} works for you",
    step1Title: "Describe project",
    step1Desc: "Describe in a few steps what craft service you need. No expertise required.",
    step2Title: "We match for you",
    step2Desc: "Our algorithm finds the matching craft businesses from your region. Hand-picked, not random.",
    step3Title: "Receive offers",
    step3Desc: "Within 24 hours, up to 5 qualified businesses contact you with concrete offers.",
    stepsBanner: "Completely free · No hidden costs · No commission",
    exampleTitle: "This is what a",
    exampleAccent: "project inquiry",
    exampleSuffix: " looks like",
    exampleLabel: "Example project inquiry",
    exampleName: "Complete bathroom renovation",
    exampleRegion: "Solingen",
    exampleObject: "Single-family house",
    exampleUrgency: "Within 1 month",
    exampleMatched: "4 matching businesses found",
    regionLabel: "Region",
    objectLabel: "Property",
    timeframeLabel: "Timeframe",
    resultLabel: "Result",
    exampleResult: "Within <strong>24 hours</strong>, this client received 4 matching offers.",
    exampleCta: "Submit your own project inquiry",
    whyTitle: "Why clients use {{brand}}",
    why1: "Completely free, no hidden fees or commissions",
    why2: "GDPR-compliant data processing in Germany",
    why3: "Your data is only shared with matching craft businesses (max. 5) after consent",
    why4: "Hand-picked businesses, max. 5 per inquiry",
    why5: "Response within 24 hours",
    why6: "Personal support for questions",
    whyTrust: "Trusted by clients across the DACH region",
    ctaTitle: "Ready to find the right",
    ctaAccent: "craft business",
    ctaSuffix: "?",
    ctaDesc: "Describe your project. We take care of the rest.\nFree, non-binding and without obligation.",
    ctaBtn: "Find a craft business now",
    ctaSubline: "Free · Non-binding · No sharing without consent · Response within 24h",
    ctaPhone: "Have questions? Call us at",
    ctaForCraft: "For craft businesses →",
    ctaForLeads: "Project inquiries for businesses →",
    ctaContact: "Contact →",
  },
  leads: {
    seoTitle: "Receive project inquiries – Qualified orders for craft businesses",
    seoDesc: "Pre-qualified project inquiries from DACH: orders matching your trade, region & capacity. No cold calling, no subscriptions. Pay only on acceptance. Max. 5 businesses per inquiry.",
    trustDach: "🇩🇪 🇦🇹 🇨🇭 DACH-wide",
    trustGdpr: "GDPR-compliant",
    trustMax5: "Max. 5 businesses per inquiry",
    trustPayOnAccept: "Pay only on acceptance",
    trustNoSubs: "No subscriptions",
    trustCancelAnytime: "Cancel anytime",
    heroTitle: "Qualified project inquiries from your region.",
    heroAccent: "You only pay when you accept",
    heroDesc: "No cold calling. No subscriptions.\nOnly real project inquiries from DACH clients.",
    heroCta: "Start free registration now",
    heroSubline: "No costs · No obligation · Pay only on acceptance",
    benefitsTitle: "Your benefits as a",
    benefitsAccent: "craft business",
    benefit1Title: "Real project inquiries",
    benefit1Desc: "Pre-qualified inquiries with real demand. No cold calling, no wasted time.",
    benefit2Title: "Full control",
    benefit2Desc: "You decide which inquiries to accept. Declining is always free.",
    benefit3Title: "Pay on acceptance",
    benefit3Desc: "Costs only arise when you actively accept an inquiry. No subscriptions, no prepayment.",
    benefitsCta: "Start free registration now",
    howTitle1: "Simple. Transparent.",
    howAccent: "Fair.",
    howDesc: "How {{brand}} works: in three steps",
    howStep1: "Capture project inquiry",
    howStep1Desc: "A client describes their project: trade, region and urgency.",
    howStep2: "Intelligent matching",
    howStep2Desc: "Our algorithm selects only craft businesses whose profile truly matches the project.",
    howStep3: "You decide",
    howStep3Desc: "You see the inquiry in advance and only pay when you actively accept it.",
    howBanner: "No subscription · No minimum order · No obligation",
    faqQ1: "What does 'qualified project inquiry' mean?",
    faqA1: "An inquiry with real project need, clear trade, region and contact details.",
    faqQ2: "When do costs arise?",
    faqA2: "Only when you actively accept an inquiry.",
    faqQ3: "Can I decline inquiries?",
    faqA3: "Yes, anytime and at no cost.",
    trustTitle: "Why craft businesses",
    trustAccent: "choose {{brand}}",
    trust1: "No prepayment: you only pay after acceptance",
    trust2: "Transparent project info before your decision",
    trust3: "Region & trades individually configurable",
    trust4: "Fairly distributed, no lead overload, no price war",
    trust5: "Replacement guaranteed for misqualification",
    trustCta: "Start free registration now",
    exampleTitle: "This is what a",
    exampleAccent: "project inquiry",
    exampleSuffix: " looks like",
    exampleLabel: "New project inquiry",
    exampleName: "Bathroom renovation single-family house",
    exampleMax5: "This inquiry was sent to max. <strong>5 businesses</strong>.",
    exampleCta: "Receive such inquiries",
    regionLabel: "Region",
    tradeLabel: "Trade",
    budgetLabel: "Budget",
    urgencyLabel: "Urgency",
    objectLabel: "Property",
    securityTitle: "Trust is the",
    securityAccent: "foundation",
    security1: "GDPR-compliant data processing in Germany",
    security2: "No sharing of contact data without your consent",
    security3: "Personal support & clear, fair rules",
    security4: "Transparent prices per inquiry, no hidden costs",
    securityTrust: "Trusted by pilot customers across the DACH region",
    ctaTitle: "Ready for real",
    ctaAccent: "project inquiries?",
    ctaDesc: "Register now and decide for yourself\nwhich inquiries you want to accept.",
    ctaBtn: "Start free registration now",
    ctaSubline: "No costs · No obligation · Pay only on acceptance · Cancel anytime",
    ctaForCraft: "Benefits for craft businesses →",
    ctaForSearch: "For project seekers →",
    ctaAbout: "About CRAFTFINDUS →",
  },
  feedback: {
    seoThankYou: "Feedback – Thank you",
    thankYouTitle: "Thank you!",
    thankYouDesc: "Your feedback has been successfully submitted and helps us improve the quality of our service providers.",
    errorTitle: "Error",
    invalidLink: "Invalid or expired link.",
    formTitle: "Your Feedback",
    formDesc: "Rate your experience with <strong>{{provider}}</strong>",
    submitBtn: "Submit feedback",
    submitting: "Sending…",
    anonymous: "Your feedback is anonymous to the service provider.",
    answerPlaceholder: "Your answer…",
  },
  withdraw: {
    seoTitle: "Withdraw request",
    seoDesc: "Withdraw your project inquiry at CRAFTFINDUS.",
    loading: "Verifying link…",
    errorTitle: "Invalid link",
    noToken: "No token provided.",
    alreadyTitle: "Already withdrawn",
    alreadyDesc: "This request has already been cancelled.",
    title: "Withdraw request",
    confirmQuestion: "Do you really want to withdraw the following request?",
    requestNumber: "Request No.",
    category: "Category",
    company: "Company",
    createdAt: "Created on",
    reasonLabel: "Reason",
    reasonPlaceholder: "Why do you want to withdraw the request?",
    reasonMin: "At least 5 characters required",
    warning: "By withdrawing, all assigned craft businesses will be notified and the request will be cancelled. This action cannot be undone.",
    submitBtn: "Permanently withdraw request",
    submitting: "Withdrawing request…",
    successTitle: "Request withdrawn",
    successDesc: "Your request has been successfully cancelled.",
    notifiedOne: "{{count}} assigned craft business was notified.",
    notifiedMany: "{{count}} assigned craft businesses were notified.",
  },
  profileEdit: {
    title: "Edit profile",
    subtitle: "Company data, address, contact, trades and limits",
    companySection: "Company",
    companyName: "Company name *",
    companyType: "Company type",
    companyTypePlaceholder: "\u2013 Please select \u2013",
    legalName: "Legal name",
    legalNamePlaceholder: "e.g. Sample GmbH",
    vatId: "VAT ID",
    vatIdPlaceholder: "DE123456789",
    website: "Website",
    addressSection: "Address",
    street: "Street & house number",
    postalCode: "Postal code",
    city: "City",
    country: "Country",
    contactSection: "Primary contact",
    contactName: "Contact person *",
    contactRole: "Role",
    contactRolePlaceholder: "e.g. Managing Director",
    contactEmail: "Email",
    contactPhone: "Phone",
    contactPhonePlaceholder: "+49 ...",
    additionalContacts: "Additional contacts",
    additionalContactsDesc: "Additional contact persons in your company",
    addContact: "Add",
    createContact: "Create contact",
    noContacts: "No additional contacts yet",
    contactLabel: "Contact {{n}}",
    primaryContact: "Primary contact",
    nameRequired: "Name *",
    emailRequired: "Email *",
    tradesSection: "Trades & services",
    tradesLabel: "Trades",
    stackLabel: "Technology stack",
    stackLoading: "Loading tags...",
    limitsSection: "Monthly limit",
    monthlyLimit: "Monthly limit",
    monthlyLimitDesc: "Maximum project inquiries per month you want to receive.",
    monthlyLimitUnit: "Project inquiries / month",
    noProfile: "No profile found.",
    createProfile: "Create profile",
    saved: "Profile saved",
    saveError: "Error saving",
    notLoggedIn: "Not logged in",
    saving: "Saving...",
    saveBtn: "Save profile",
  },
  datenschutz: {
    seoTitle: "Privacy Policy",
    seoDesc: "Privacy policy of CRAFTFINDUS. Information about processing personal data under GDPR.",
    title: "Privacy Policy",
    s1Title: "1. Controller",
    s1Intro: "The controller within the meaning of the General Data Protection Regulation (GDPR) and other national data protection laws is:",
    s2Title: "2. General information on data processing",
    s2Text: "We process personal data of our users only insofar as this is necessary for the provision of a functional platform and our content and services. Processing of personal data takes place regularly only with the user's consent or in cases where prior consent cannot be obtained for practical reasons and processing is permitted by law.",
    s3Title: "3. Legal bases for processing",
    s3a: "Art. 6(1)(a) GDPR: Consent of the data subject",
    s3b: "Art. 6(1)(b) GDPR: Processing for the performance of a contract or pre-contractual measures",
    s3c: "Art. 6(1)(c) GDPR: Processing for compliance with a legal obligation",
    s3f: "Art. 6(1)(f) GDPR: Processing for the purposes of legitimate interests",
    s4Title: "4. Provision of the platform and log files",
    s4Text1: "Each time our platform is accessed, our system automatically collects data and information from the accessing computer. The following data is collected:",
    s4Li1: "Browser type and version used",
    s4Li2: "User's operating system",
    s4Li3: "User's IP address (anonymized)",
    s4Li4: "Date and time of access",
    s4Li5: "Websites from which the user's system accesses our platform (referrer)",
    s4Text2: "The data is stored in our system's log files. This data is not stored together with other personal data of the user. The legal basis is Art. 6(1)(f) GDPR. Storage in log files ensures the functionality of the platform and defense against attacks.",
    s5Title: "5. Registration and user account",
    s5Text1: "On our platform, we offer users the option to register by providing personal data. For craft businesses, this includes in particular:",
    s5Li1: "Email address",
    s5Li2: "Company name and contact details",
    s5Li3: "Description of craft services offered",
    s5Li4: "Regional availability and specializations",
    s5Li5: "SEPA direct debit mandate (IBAN, account holder) for billing",
    s5Text2: "Processing of this data is based on Art. 6(1)(b) GDPR for the performance of pre-contractual measures and contract fulfillment. Data is deleted as soon as it is no longer necessary for its purpose and no statutory retention obligations apply.",
    s6Title: "6. Project inquiries by clients",
    s6Text1: "Clients who submit a project inquiry via {{brand}} provide the following data:",
    s6Li1: "Type of craft project",
    s6Li2: "Property type and project size",
    s6Li3: "Contact details (name, email, phone)",
    s6Li4: "Location / Region",
    s6Li5: "Urgency and budget range",
    s6Text2: "This data is used to identify suitable craft businesses and forward the inquiry to 3 to 5 qualified businesses. The legal basis is Art. 6(1)(b) GDPR (pre-contractual measures) and Art. 6(1)(f) GDPR (legitimate interest in matching suitable craft services).",
    s7Title: "7. Matching and data sharing with craft businesses",
    s7Text1: "As part of the matching process, inquiry data is shared with selected craft businesses registered on the platform. Sharing is limited to data necessary for contact and quotation. Craft businesses only gain access to the client's full contact details after accepting an inquiry.",
    s7Text2: "The legal basis is Art. 6(1)(b) GDPR. Sharing occurs exclusively within the intended platform purpose.",
    s8Title: "8. Payment data and payment methods",
    s8Text: "For billing services to craft businesses, we collect payment data (IBAN, account holder). This data is used exclusively for payment processing and stored for up to 10 years in accordance with statutory retention periods (\u00A7 147 AO, \u00A7 257 HGB). The legal basis is Art. 6(1)(b) GDPR.",
    s9Title: "9. Hosting and technical infrastructure",
    s9Text: "Our platform is hosted on servers within the European Union. Data processing is based on Art. 6(1)(f) GDPR and, where applicable, Art. 28 GDPR (commissioned processing). We have concluded data processing agreements (DPAs) with our hosting providers.",
    s10Title: "10. Cookies",
    s10Text1: "Our platform uses cookies. Cookies are small text files stored on your device by your browser. They serve to make our offering more user-friendly and effective.",
    s10Text2: "We distinguish between the following cookie categories:",
    s10Necessary: "Necessary cookies: These cookies are required for the operation of the platform and cannot be deactivated. They include cookies for authentication, storing your cookie settings, and ensuring platform functionality. Legal basis is Art. 6(1)(f) GDPR.",
    s10Analytics: "Analytics cookies: These cookies help us understand how visitors interact with our platform by collecting and reporting information anonymously. They are only set with your consent. Legal basis is Art. 6(1)(a) GDPR.",
    s10Marketing: "Marketing cookies: These cookies are used to display relevant advertising to visitors. They are only set with your consent. Legal basis is Art. 6(1)(a) GDPR.",
    s10Text3: "On your first visit to our platform, you will be informed about the use of cookies via a cookie banner and asked for your consent. You can adjust your settings at any time via the cookie banner. You can delete cookies already set via your browser settings at any time.",
    s11Title: "11. Google Analytics",
    s11Text1: "We use Google Analytics on our platform, a web analytics service provided by Google Ireland Limited. Google Analytics uses cookies that enable analysis of your use of our platform.",
    s11Text2: "We have activated IP anonymization, so your IP address is shortened by Google within the European Union or other contracting states of the European Economic Area before transmission.",
    s11Text3: "Google Analytics is only activated if you have consented to the use of analytics cookies via our cookie banner. Legal basis is Art. 6(1)(a) GDPR (consent). You can revoke your consent at any time by adjusting your cookie settings.",
    s11Text4: "For more information about how Google handles user data, see Google's privacy policy:",
    s12Title: "12. SSL/TLS encryption",
    s12Text: "This site uses SSL/TLS encryption for security reasons and to protect the transmission of confidential content. You can recognize an encrypted connection by the browser address bar changing from 'http://' to 'https://' and the lock symbol in your browser bar.",
    s13Title: "13. Rights of data subjects",
    s13Intro: "As a data subject, you have the following rights:",
    s13Art15: "Right of access (Art. 15 GDPR): You have the right to request information about your personal data processed by us.",
    s13Art16: "Right to rectification (Art. 16 GDPR): You have the right to request immediate rectification of inaccurate data.",
    s13Art17: "Right to erasure (Art. 17 GDPR): You have the right to request deletion of your data, unless statutory retention obligations apply.",
    s13Art18: "Right to restriction (Art. 18 GDPR): You have the right to request restriction of processing of your data.",
    s13Art20: "Right to data portability (Art. 20 GDPR): You have the right to receive your data in a structured, commonly used and machine-readable format.",
    s13Art21: "Right to object (Art. 21 GDPR): You have the right to object to processing of your data at any time, insofar as processing is based on Art. 6(1)(f) GDPR.",
    s13Art7: "Right to withdraw consent (Art. 7(3) GDPR): You have the right to withdraw consent at any time.",
    s13Art77: "Right to lodge a complaint (Art. 77 GDPR): You have the right to lodge a complaint with a supervisory authority.",
    s14Title: "14. Data deletion and storage period",
    s14Text: "Personal data is deleted or blocked as soon as the purpose of storage ceases to apply. Storage beyond this only occurs if provided for by European or national legislation.",
    s15Title: "15. Changes to the privacy policy",
    s15Text1: "We reserve the right to adapt this privacy policy to ensure it always complies with current legal requirements.",
    s15Text2: "As of: February 2026",
  },
  impressum: {
    seoTitle: "Legal Notice",
    seoDesc: "Legal notice of CRAFTFINDUS. Information according to \u00A7 5 TMG.",
    title: "Legal Notice",
    s1Title: "Information according to \u00A7 5 TMG",
    s2Title: "Contact",
    s3Title: "Liability for content",
    s3Text: "As a service provider, we are responsible for our own content on these pages in accordance with \u00A7 7 para.1 TMG under general law. According to \u00A7\u00A7 8 to 10 TMG, however, we are not obligated to monitor transmitted or stored third-party information or to investigate circumstances that indicate illegal activity.",
    s4Title: "Liability for links",
    s4Text: "Our offering contains links to external third-party websites over whose content we have no influence. Therefore, we cannot accept any liability for this third-party content.",
    s5Title: "Copyright",
    s5Text: "The content and works created by the site operators on these pages are subject to German copyright law. Duplication, processing, distribution and any kind of exploitation outside the limits of copyright law require the written consent of the respective author or creator.",
  },
  barrierefreiheit: {
    seoTitle: "Accessibility Statement",
    seoDesc: "Accessibility statement of CRAFTFINDUS in accordance with BFSG and BITV 2.0.",
    title: "Accessibility Statement",
    scopeTitle: "Scope",
    scopeText: "This accessibility statement applies to the publicly accessible website",
    scopeSuffix: "of",
    compatTitle: "Compatibility status",
    compatText1: "This website is largely compatible with the requirements of the Barrierefreiheitsst\u00E4rkungsgesetz (BFSG) and BITV 2.0, based on EU Directive 2019/882 (European Accessibility Act).",
    compatText2: "We follow the Web Content Accessibility Guidelines (WCAG) 2.1 Level AA and continuously work to improve the accessibility of our website.",
    measuresTitle: "Accessibility measures",
    measure1: "Semantic HTML structure with correct heading hierarchy",
    measure2: "Full keyboard operability (including skip navigation)",
    measure3: "Sufficient color contrasts per WCAG 2.1 AA",
    measure4: "Alternative texts for all informative images",
    measure5: "Correct form labels and error messages",
    measure6: "Screen reader support through ARIA attributes",
    measure7: "Respecting user preference 'reduce motion' (prefers-reduced-motion)",
    measure8: "Responsive design for different devices and zoom levels",
    limitationsTitle: "Known limitations",
    limitationsIntro: "Despite our efforts, the following areas may still have limitations:",
    limitation1: "Older PDF documents may not be fully accessible",
    limitation2: "Some interactive diagrams in the operator area have limited keyboard operability",
    limitationsOutro: "We are actively working to address these limitations.",
    feedbackTitle: "Feedback and contact",
    feedbackIntro: "If you encounter barriers or have suggestions for improvement, please contact us:",
    feedbackResponse: "We aim to respond to your concern within 2 weeks.",
    enforcementTitle: "Enforcement procedure",
    enforcementText: "If you do not receive a satisfactory response within a reasonable period after contacting us, you can contact the relevant enforcement body. You can find the responsible market surveillance authority for the BFSG via the",
    enforcementLink: "Website of the Federal Ministry of Labour and Social Affairs",
    enforcementSuffix: ".",
    createdTitle: "Creation of this statement",
    createdText: "This statement was created on February 7, 2026 and is regularly reviewed and updated.",
  },
  sucheHeader: {
    cta: "Find a craft business",
    logoAlt: "CRAFTFINDUS | Find a craft business",
  },
  leadsHeader: {
    cta: "Receive project inquiries",
    ctaTooltip: "You decide which inquiries to accept",
    logoAlt: "CRAFTFINDUS | Qualified project inquiries for craft businesses",
  },
  leadsFooter: {
    imprint: "Imprint",
    privacy: "Privacy",
    contact: "Contact",
    faq: "FAQ",
    forCraft: "For craft businesses",
    motto: "Find \u00B7 Connect \u00B7 Solve",
  },
  op: {
    loadingPortal: "Loading operator portal...",
    portalLabel: "CRAFTFINDUS Operator",
    roleLabel: "Operator",
    ctaNewProvider: "Add new business",
    ctaNewProviderDesc: "Add craft business",
    navDashboard: "Dashboard",
    navRegistrations: "Registrations",
    navRequests: "Project Inquiries",
    navProviders: "Craft Businesses",
    navOpportunities: "Project Matching",
    navClaims: "Claims",
    navBilling: "Billing",
    navCosts: "Cost Overview",
    navPricing: "Pricing",
    navMatching: "Matching",
    navSettings: "Settings",
    navAudit: "Audit Log",
    navSales: "Sales Dashboard",
    navROI: "ROI Calculator",
    navFeedback: "Feedback",
    dashTitle: "Dashboard",
    dashSubtitle: "Overview of all activities",
    realtimeActive: "Realtime active – New inquiries are automatically matched",
    realtimeConnecting: "Connecting…",
    kpiNew7d: "New Projects (7d)",
    kpiDelivered7d: "Delivered (7d)",
    kpiFailed: "Failed",
    kpiClaimsOpen: "Claims open",
    kpiBlocked: "Businesses blocked",
    kpiRevenue: "Revenue (month)",
    liveMatching: "Live Matching",
    waitingForRequests: "Waiting for new inquiries…",
    recentRequests: "Recent Project Inquiries",
    noRequests: "No inquiries available",
    openClaims: "Open Claims",
    noOpenClaims: "No open claims",
    provTitle: "Businesses",
    provSubtitle: "Manage craft businesses",
    filterAll: "All",
    filterActive: "Active",
    filterPending: "Pending",
    filterSuspended: "Suspended",
    filterPastDue: "Past Due",
    createProvider: "+ Add Business",
    colProvider: "Business",
    colContact: "Contact",
    colRegion: "Region",
    colStatus: "Status",
    colBilling: "Billing",
    colSEPA: "SEPA",
    colMandate: "Mandate",
    colLimit: "Limit",
    colCreated: "Created",
    statusActive: "Active",
    statusPending: "Pending",
    statusSuspended: "Suspended",
    noProviders: "No businesses found",
    reqTitle: "Project Inquiries",
    reqSubtitle: "All incoming project inquiries",
    reqDetailTitle: "Inquiry Details",
    backToList: "Back to list",
    filterUnmatched: "Unmatched",
    filterMatched: "Matched",
    colNumber: "No.",
    colCategory: "Category",
    colCompany: "Company",
    colUrgency: "Urgency",
    colPrice: "Price",
    colDate: "Date",
    matched: "Matched",
    open: "Open",
    catSupport: "Small Repair",
    catManaged: "Maintenance Contract",
    catProject: "Construction Project",
    catSecurity: "Emergency Service",
    catCloud: "Renovation",
    urgImmediate: "Immediate",
    urgWithin48h: "48 Hours",
    urgWithin7d: "7 Days",
    urgPlanned: "Planned",
    decSelf: "Self",
    decTeam: "Team",
    decRecommend: "Recommendation",
    labelCategory: "Category",
    labelUrgency: "Urgency",
    labelRegion: "Region",
    labelRemote: "Remote",
    labelOnsite: "On-site",
    labelCompliance: "Compliance",
    labelDecision: "Decision",
    labelBudget: "Budget",
    labelPrice: "Price",
    labelProjectSize: "Project Size",
    labelSystems: "Systems",
    labelUsers: "Users",
    labelDescription: "Description",
    labelContext: "Context",
    labelStackTags: "Trade Tags",
    labelOpportunities: "Opportunities",
    labelMatchRuns: "Match Runs",
    labelRequester: "Requester",
    labelRiskFlags: "Risk Flags",
    selected: "selected",
    startMatching: "Start Matching",
    matchingRunning: "Matching running...",
    matchingStarted: "Matching started",
    matchingFailed: "Matching failed",
    deleteRequest: "Delete Inquiry",
    deleteRequestTitle: "Delete Inquiry?",
    deleteRequestDesc: "The inquiry <strong>{{number}}</strong> and all related opportunities, match runs, and data will be permanently deleted.",
    cancelAction: "Cancel",
    deleting: "Deleting...",
    deleteForever: "Delete permanently",
    requestDeleted: "Inquiry {{number}} deleted",
    deleteError: "Error deleting",
    loadError: "Error loading inquiries",
    requestNotFound: "Inquiry not found",
    regTitle: "Registrations",
    regSubtitle: "Review & manage craft business registrations",
    regFilterPending: "Pending",
    regFilterApproved: "Approved",
    regFilterRejected: "Rejected",
    regNew: "New",
    regNoEntries: "No registrations in this category",
    regSelect: "Select a registration",
    regApproved: "Registration approved – Credentials are being created",
    regRejected: "Registration rejected",
    regCreated: "Registration created",
    regUpdated: "Registration updated",
    regDeleted: "Registration deleted",
    regDeleteTitle: "Delete Registration?",
    regDeleteDesc: "The registration of <strong>{{company}}</strong> will be permanently deleted.",
    oppTitle: "Project Matching",
    oppSubtitle: "Monitor all matched project inquiries",
    filterNew: "New",
    filterInReview: "In Review",
    filterFailed: "Failed",
    filterHold: "Hold",
    colScore: "Score",
    colDelivery: "Delivery",
    selectOpp: "Select an inquiry",
    resend: "Resend",
    resendTriggered: "Resend triggered",
    labelHoldReason: "Hold Reason",
    labelRequestCompany: "Company (Inquiry)",
    labelRequestEmail: "Email (Inquiry)",
    labelLocation: "Location",
    claimTitle: "Claims",
    claimSubtitle: "Review and decide on claims",
    claimFilterOpen: "Open",
    claimFilterDecided: "Decided",
    claimNone: "No claims",
    claimSelectDetail: "Select a claim for details",
    claimDetailTitle: "Claim Detail",
    claimReason: "Reason",
    claimComment: "Comment",
    claimOppPrice: "Opportunity Price",
    claimSubmittedAt: "Submitted on",
    claimOperatorNote: "Operator Note",
    claimCredit: "Credit (Cents)",
    claimApprove: "Approve",
    claimReject: "Reject",
    claimApproved: "Claim approved",
    claimRejected: "Claim rejected",
    billTitle: "Billing Monitor",
    billSubtitle: "Billing, mandates, and delivery status",
    billOverdue: "Overdue",
    billMandate: "Payment Methods",
    billEmailFailures: "Email Failures",
    billMonthClose: "Month Close",
    billInvoices: "Invoices",
    billCloseMonth: "Close Month",
    billClosing: "Closing...",
    billMonthClosed: "Month {{month}} closed",
    noEntries: "No entries",
    colOverdueSince: "Overdue since",
    colMethods: "Methods",
    colOpportunity: "Opportunity",
    colError: "Error",
    colAttempts: "Attempts",
    colMonth: "Month",
    colAmount: "Amount",
    colNet: "Net",
    colGross: "Gross",
    colPeriod: "Period",
    costTitle: "Cost Overview",
    costSubtitle: "Accepted project inquiries per business · Monthly billing",
    costProviders: "Businesses",
    costAccepted: "Accepted Project Inquiries",
    costTotal: "Total ({{month}})",
    costVatNote: "excl. VAT · Billed at month end",
    costNoAccepted: "No accepted project inquiries in {{month}}",
    colAccepted: "Accepted",
    colAmountNet: "Amount (net)",
    colAmountGross: "Amount (gross)",
    costTotalRow: "Total",
    costFooter: "All amounts in EUR · VAT 19% · Billing at end of calendar month",
    auditTitle: "Audit Log",
    auditSubtitle: "Global activity log",
    auditAllEntities: "All Entities",
    auditAllEvents: "All Events",
    auditRetention: "Retention",
    auditCSV: "CSV Export",
    auditRetentionLabel: "Auto-delete entries after:",
    auditDays: "Days",
    auditSaved: "Retention set to {{days}} days",
    auditPurgeConfirm: "Delete all audit log entries older than {{days}} days now?",
    auditPurged: "Old entries deleted",
    auditPurgeNow: "Purge now",
    auditCurrentRetention: "Currently saved: <span>{{days}} days</span>. A cron job can be configured for automatic deletion.",
    colTimestamp: "Timestamp",
    colEvent: "Event",
    colEntity: "Entity",
    colActor: "Actor",
    colMeta: "Meta",
    auditEntries: "{{count}} entries · Page {{page}} of {{total}}",
    setTitle: "Settings",
    setSubtitle: "Platform Configuration",
    setProviderTemplates: "Business Templates",
    setCustomerTemplates: "Customer Templates",
    setGraph: "Microsoft Graph",
    setUsers: "User Management",
    setApiKeys: "API Keys",
    setSaveTemplates: "Save Templates",
    setTemplatesSaved: "Email templates saved",
    setGraphTitle: "Microsoft Graph API",
    setGraphDesc: "Configuration for email delivery via Graph API (Mail.Send)",
    setTenantId: "Tenant ID",
    setClientId: "Client ID",
    setClientSecret: "Client Secret",
    setSenderEmail: "Sender Email",
    setRetryPolicy: "Retry Policy",
    setMaxAttempts: "Max. Attempts",
    setIntervals: "Intervals (min)",
    setIntervalsHint: "Comma-separated, e.g. 5,10,30",
    setSaveGraph: "Save Graph Settings",
    setSavingGraph: "Saving...",
    setGraphSaved: "Microsoft Graph settings saved",
    setTestEmail: "Send Test Email",
    setTestTitle: "Send Test Email",
    setTestDesc: "Enter the recipient address for a test email via Microsoft Graph.",
    setTestRecipient: "Recipient Email",
    setTestSending: "Sending...",
    setTestSend: "Send",
    setTestSent: "Test email sent to {{email}}",
    profTitle: "My Profile",
    profSubtitle: "Personal settings and security",
    profAccess: "Operator Access",
    profDisplayName: "Display Name",
    profDisplayNamePlaceholder: "Your name",
    profSaveName: "Save Name",
    profNameSaved: "Name saved",
    profChangePassword: "Change Password",
    profNewPassword: "New Password",
    profNewPasswordPlaceholder: "At least 6 characters",
    profConfirmPassword: "Confirm Password",
    profConfirmPasswordPlaceholder: "Repeat password",
    profPasswordChanged: "Password changed successfully",
    profPasswordMinLength: "Password must be at least 6 characters",
    profPasswordMismatch: "Passwords do not match",
    profAccountDetails: "Account Details",
    profEmail: "Email",
    profCreatedAt: "Account created",
    profLastSignIn: "Last sign in",
    profSaving: "Saving...",
    pricTitle: "Pricing",
    pricSubtitle: "Plans, add-ons & price configuration",
    pricPlans: "Plans",
    pricAddons: "Add-ons",
    pricPreview: "Preview Pricing Page",
    pricNewPlan: "New Plan",
    pricEditPlan: "Edit Plan",
    pricPlanSaved: "Plan saved",
    pricPlanDeleted: "Plan deleted",
    pricDeleteConfirm: "Delete plan?",
    pricNewAddon: "New Add-on",
    pricEditAddon: "Edit Add-on",
    pricAddonSaved: "Add-on saved",
    pricAddonDeleted: "Add-on deleted",
    pricKey: "Key",
    pricName: "Name",
    pricPriceCents: "Price (cents)",
    pricInclLeads: "Incl. Leads",
    pricMaxDeliveries: "Max. Deliveries",
    pricMaxRadius: "Max. Radius (km)",
    pricMaxTrades: "Max. Trades",
    pricSort: "Sort Order",
    pricFeaturesJSON: "Features (JSON Array)",
    pricActiveLabel: "Active",
    pricInactive: "Inactive",
    pricEdit: "Edit",
    pricExtraLeads: "Extra Leads",
    matchTitle: "Matching",
    matchSubtitle: "Matching Engine Configuration",
    matchWeights: "Weights",
    matchLimits: "Limits & Fairness",
    matchAI: "AI Matching",
    matchScoreWeights: "Score Weights",
    matchScoreDesc: "Distribution of 100 points across matching dimensions.",
    matchCurrent: "Current:",
    matchStackMatch: "Trade Match",
    matchStackMatchDesc: "Match between business profile and project inquiry",
    matchUrgencyFit: "SLA / Urgency",
    matchUrgencyFitDesc: "SLA response time vs. inquiry urgency",
    matchGeoFit: "Geography",
    matchGeoFitDesc: "Location and remote compatibility",
    matchReliability: "Reliability",
    matchReliabilityDesc: "Acceptance rate and response time of the business",
    matchQuality: "Quality",
    matchQualityDesc: "Internal quality score of the business",
    matchLimitsTitle: "Limits & Fairness",
    matchLimitsDesc: "Control business selection and fairness rules",
    matchMaxProviders: "Max. Businesses per Inquiry",
    matchMaxProvidersDesc: "How many businesses are matched per inquiry",
    matchMinScore: "Min. Score Threshold",
    matchMinScoreDesc: "Businesses below this score are excluded",
    matchFairnessDelta: "Fairness Delta",
    matchFairnessDeltaDesc: "Score difference for fairness rotation",
    matchExpiryHours: "Expiry Time (hours)",
    matchExpiryDesc: "Inquiry expires after this time",
    matchOverage: "Overage Tolerance (%)",
    matchOverageDesc: "= Business may exceed its monthly limit by {{percent}}%",
    matchOverageExample: "Example: With limit 20 and 20% tolerance, the business can accept up to 24 inquiries",
    matchSaveConfig: "Save Configuration",
    matchSaving: "Saving...",
    matchSaved: "Matching configuration saved",
    matchWeightError: "Weights must total 100 (currently: {{total}})",
    matchAITitle: "AI-Enhanced Matching",
    matchAIDesc: "AI-powered analysis and evaluation of inquiries",
    matchAIModel: "AI Model",
    matchAIFunctions: "AI Functions",
    matchAIEnhanceReasons: "Enhance match reasons",
    matchAIEnhanceReasonsDesc: "AI generates detailed explanations why a business is a good fit",
    matchAIAdjustScores: "Score Adjustments",
    matchAIAdjustScoresDesc: "AI can adjust scores based on context analysis",
    matchAIMaxAdjustment: "Max. Score Adjustment (±)",
    matchAIMaxAdjustmentDesc: "Maximum points AI may add/subtract from scores",
    matchAIHowTitle: "How AI Matching Works",
    fbTitle: "Feedback",
    fbSubtitle: "Manage and send customer feedback",
    fbRequests: "Requests",
    fbConfig: "Configuration",
    fbWonWithout: "Won inquiries without feedback ({{count}})",
    fbSend: "Send",
    fbEmailSent: "Feedback email sent",
    fbAllRequests: "All Feedback Requests",
    fbNoRequests: "No feedback requests created yet.",
    fbResend: "Resend",
    fbEmailResent: "Email resent",
    fbResponses: "Responses",
    fbNoResponses: "No responses.",
    fbConfigDesc: "Configure the questions customers see in the feedback form.",
    fbEditQuestion: "Edit Question",
    fbNewQuestion: "Create New Question",
    fbQuestionText: "Question Text",
    fbType: "Type",
    fbTypeRating: "Star Rating",
    fbTypeText: "Free Text",
    fbTypeYesNo: "Yes/No",
    fbTypeScale: "Scale (1-10)",
    fbSaved: "Saved",
    salesTitle: "Sales Dashboard",
    salesSubtitle: "KPIs & sales argumentation aids",
    salesTotalProviders: "Total Businesses",
    salesActiveProviders: "Active Businesses",
    salesNewRegs7d: "New Registrations (7d)",
    salesAvgAcceptance: "Avg. Acceptance Rate",
    salesOpps30d: "Opportunities (30d)",
    salesDelivered30d: "Delivered (30d)",
    salesRevenue: "Revenue (month)",
    salesAvgScore: "Avg. Match Score",
    salesElevatorPitch: "Elevator Pitch (30 sec.)",
    salesCopy: "Copy",
    salesCopied: "Copied",
    salesTop5: "Top 5 Sales Arguments",
    salesArgRiskFree: "Risk-Free",
    salesArgRiskFreeDesc: "No contracts, no base fee, pay only on acceptance",
    salesArgQuality: "Quality",
    salesArgQualityDesc: "Pre-qualified inquiries, algorithm-based matching",
    salesArgFairness: "Fairness",
    salesArgFairnessDesc: "Max. 3–5 competitors, no price war",
    salesArgFast: "Fast",
    salesArgFastDesc: "Registered in 15 minutes, first leads within hours",
    salesArgFlexible: "Flexible",
    salesArgFlexibleDesc: "Weekly limit adjustable, pausable at any time",
    salesStrongestNumbers: "The 3 Strongest Numbers",
    salesAcceptanceRate: "Acceptance Rate",
    salesResponseTime: "Avg. Response Time",
    salesProvidersPerRequest: "Craftsmen per inquiry",
    salesObjectionHandling: "Objection Handling",
    salesBenchmarks: "Business KPI Benchmarks (for argumentation)",
    salesKPI: "KPI",
    salesBenchmark: "CRAFTFINDUS Benchmark",
    roiTitle: "ROI Calculator",
    roiSubtitle: "Interactive calculator for sales conversations",
    roiParams: "Adjust Parameters",
    roiLeadsPerMonth: "Leads per month",
    roiAvgLeadPrice: "Avg. Lead Price (€)",
    roiConversion: "Conversion Rate Lead → Customer (%)",
    roiAvgDealValue: "Avg. Deal Value (€)",
    roiCurrentCAC: "Current Acquisition Cost per Customer (€)",
    roiIndustryAvg: "Industry average: 1,500–3,000 €",
    roiScenarios: "Quick Scenarios",
    roiMonthlyCost: "Monthly CRAFTFINDUS Cost",
    roiExpectedCustomers: "Expected New Customers",
    roiExpectedRevenue: "Expected Revenue",
    roiLabel: "ROI",
    roiCACComparison: "Acquisition Cost Comparison",
    roiCurrentCACLabel: "Current CAC",
    roiCraftfindusCAC: "CRAFTFINDUS CAC",
    roiSavingsPerCustomer: "Savings per Customer",
    roiCurrent: "Current",
    roiWithCraftfindus: "With CRAFTFINDUS",
    roiAnnualSavings: "Annual Savings on Acquisition Costs",
    roiBasedOn: "Based on {{count}} new customers/year",
    roiTalkingPoint: "Talking Point",
    roiTalkingPointText: "If you accept {{leads}} leads per month at an average of {{price}} €, that costs you {{cost}} € per month. With a conversion rate of {{conv}} % and an average deal value of {{deal}} €, that gives you expected revenue of {{revenue}} € – an ROI of {{roi}} %.",
    roiScenarioFreelancer: "Freelancer (small)",
    roiScenarioMedium: "System integrator (medium)",
    roiScenarioLarge: "MSP (large)",
    // Sales
    salesElevatorPitchText: "CRAFTFINDUS delivers pre-qualified project inquiries to craft businesses that exactly match their profile. Instead of cold calling or bidding platforms, you receive leads where you compete against a maximum of 4 other businesses – and you only pay when you actively accept the lead. No contracts, no risk, ready to start immediately.",
    salesObj1Q: "That's too expensive for me.",
    salesObj1A: "What does a qualified new customer cost you today? Most craft businesses are at 1,500–3,000 €. A CRAFTFINDUS lead starts at 39 € – pre-qualified. That's not an expense, it's an investment with immediate ROI.",
    salesObj2Q: "We get enough customers through referrals.",
    salesObj2A: "Referrals are the best channel – but not plannable and not scalable. CRAFTFINDUS complements your existing flow with predictable, qualified project inquiries.",
    salesObj3Q: "Lead portals have never worked for us.",
    salesObj3A: "Classic portals distribute to 20–50 providers. With us, max. 5. Algorithm-based, not keyword-based. Fundamentally different approach.",
    salesObj4Q: "I'd like to test first.",
    salesObj4A: "Made exactly for that. No contract commitment, no base fee, no minimum term. Zero risk.",
    salesObj5Q: "How do I know the leads are qualified?",
    salesObj5A: "Every inquiry goes through a structured wizard + risk scoring. You see all details including match score before deciding. Plus claims process for unsuitable leads.",
    salesBenchCostPerLead: "Cost per qualified lead",
    salesBenchConvChat: "Conversion Lead → First Meeting",
    salesBenchConvCustomer: "Conversion Lead → Customer",
    salesBenchCAC: "Customer Acquisition Cost",
    pdTabProfile: "Profile & Status",
    pdTabServices: "Services & Stack",
    pdMasterData: "Master Data",
    pdContact: "Contact",
    pdPhone: "Phone",
    pdWebsite: "Website",
    pdCompanyType: "Company Type",
    pdRemote: "Remote",
    pdSLA: "SLA",
    pdMonthlyLimit: "Monthly Limit",
    pdAddress: "Address",
    pdResendWelcome: "Resend Welcome Email",
    pdResetPassword: "Reset Password",
    pdAdditionalContacts: "Additional Contacts",
    pdStatusActions: "Status & Actions",
    pdApproved: "Approved",
    pdSuspended: "Suspended",
    pdSuspendReason: "Suspension Reason:",
    pdSuspendedAt: "Suspended on:",
    pdFailedDebits: "Failed Debits:",
    pdApprove: "Approve",
    pdSuspend: "Suspend manually",
    pdSuspendPrompt: "Reason for suspension:",
    pdUnsuspend: "Unsuspend",
    pdDelete: "Delete",
    pdDeleteTitle: "Delete Craft Business?",
    pdDeleteDesc: "<strong>{{company}}</strong> will be permanently deleted. All related data (inquiries, invoices, users) will be removed. This action cannot be undone.",
    pdDeleted: "Craft business deleted",
    pdPayment: "Payment Method (Mollie)",
    pdPaymentStatus: "Status",
    pdSetupStatus: "Setup Status",
    pdMollieCustomer: "Mollie Customer",
    pdPaymentMethods: "Methods",
    pdActivateManual: "Activate manually",
    pdDeactivateManual: "Deactivate manually",
    pdPaymentUpdated: "Payment status updated",
    pdActionSuccess: "Action {{action}} successful",
    pdCategories: "Categories",
    pdNoCategories: "No categories assigned",
    pdStack: "Stack / Trades",
    pdNoStack: "No stack tags assigned",
    pdAuditLog: "Activity Log",
    pdNoAuditLog: "No activities",
    // Provider Detail - Trust & KPIs
    pdTrustKPIs: "Trust & KPIs",
    pdServiceSettings: "Service Settings",
    pdTrustProfile: "Trust Profile",
    pdTrustLevel: "Level {{level}}",
    pdTrustScore: "Trust Score: {{score}} / 100",
    pdTrustGewerbeanmeldung: "Trade licence verified",
    pdTrustVersicherung: "Liability insurance confirmed",
    pdTrustBonitaet: "Credit check passed",
    pdTrustIdentitaet: "Identity verification passed",
    pdTrustRequiredLevel: "Required for Level {{level}}",
    pdTrustActivated: "{{label}}: Activated",
    pdTrustDeactivated: "{{label}}: Deactivated",
    pdActiveBadges: "Active Badges",
    pdBadgeVerifiedBusiness: "Verified Business",
    pdBadgeInsured: "Insured",
    pdBadgePremium: "Premium Partner",
    pdBadgeTopRated: "Top Rated",
    pdBadgeFastResponse: "Fast Response",
    pdBadgeHighAcceptance: "High Acceptance Rate",
    pdKPIs: "Performance Data",
    pdLeadsReceived: "Leads Received",
    pdLeadsWon: "Leads Won",
    pdConversionRate: "Conversion Rate",
    pdDisputeRate: "Dispute Rate",
    pdAcceptanceRate: "Acceptance Rate",
    pdAvgResponseTime: "Avg. Response Time",
    pdBillingModel: "Billing Model",
    pdBillingModelSub: "Subscription",
    pdBillingModelPPC: "PPC",
    pdAvgLeadScore: "Avg. Lead Score",
    pdLimitSet: "Monthly limit set to {{limit}}",
    pdUnsuspendReason: "Unsuspended by Operator",
    pdCatManagedService: "Maintenance & Care",
    pdCatProject: "Craft Project",
    pdCatSecurity: "Security",
    pdCatCloud: "New Build & Installation",
    pdCatSupport: "Repair & Emergency",
    // Feedback extra
    fbSentAt: "Sent: {{date}}",
    fbKeyPlaceholder: "e.g. new_question",
    // Mollie Diagnostics page
    diagTitle: "Mollie Diagnostics",
    diagSubtitle: "Full validation of the payment integration",
    pcTitle: "Add Business",
    pcSubtitle: "Onboard a new craft business",
    pcCreateBtn: "Add Business",
    pcCreating: "Creating...",
    pcCreated: "Craft business created",
    pcRequiredFields: "Fill required fields (Company, Contact, Email)",
    pcLoginRequired: "Provide login email for portal access",
    pcCreateError: "Error creating",
    monthJan: "January",
    monthFeb: "February",
    monthMar: "March",
    monthApr: "April",
    monthMay: "May",
    monthJun: "June",
    monthJul: "July",
    monthAug: "August",
    monthSep: "September",
    monthOct: "October",
    monthNov: "November",
    monthDec: "December",
    // Renamed keys for component compatibility
    regFilterAll: "All",
    regEmpty: "No registrations in this category",
    regSelectHint: "Select a registration",
    regApproveSuccess: "Registration approved – Credentials are being created",
    regApproveError: "Error approving",
    regRejectSuccess: "Registration rejected",
    regRejectError: "Error rejecting",
    regCreateSuccess: "Registration created",
    regUpdateSuccess: "Registration updated",
    regDeleteSuccess: "Registration deleted",
    regDeleteError: "Error deleting",
    regDeleteConfirm: "Delete permanently",
    oppFilterNew: "New",
    oppFilterInReview: "In Review",
    oppFilterFailed: "Failed",
    oppFilterHold: "Hold",
    oppColNumber: "No.",
    oppColCategory: "Category",
    oppColProvider: "Business",
    oppColScore: "Score",
    oppColStatus: "Status",
    oppColDelivery: "Delivery",
    oppColPrice: "Price",
    oppEmpty: "No inquiries",
    oppSelectHint: "Select an inquiry",
    oppResend: "Resend",
    oppResendSuccess: "Resend triggered",
    oppDetailUrgency: "Urgency",
    oppDetailCompany: "Company (Inquiry)",
    oppDetailEmail: "Email (Inquiry)",
    oppDetailLocation: "Location",
    oppDetailHoldReason: "Hold Reason",
    claimEmpty: "No claims",
    claimSelectHint: "Select a claim for details",
    claimDetail: "Claim Detail",
    claimCreditCents: "Credit (Cents)",
    claimApproveSuccess: "Claim approved",
    claimRejectSuccess: "Claim rejected",
    billingTitle: "Billing Monitor",
    billingSubtitle: "Billing, mandates, and delivery status",
    billingOverdue: "Overdue",
    billingMandate: "Payment Methods",
    billingEmailFailures: "Email Failures",
    billingMonthClose: "Month Close",
    billingInvoices: "Invoices",
    billingCloseMonth: "Close Month",
    billingCloseSuccess: "Month {{month}} closed",
    billingEmpty: "No entries",
    billingOverdueSince: "Overdue since",
    billingMethods: "Methods",
    billingError: "Error",
    billingAttempts: "Attempts",
    billingMonth: "Month",
    billingAmount: "Amount",
    billingNet: "Net",
    billingGross: "Gross",
    billingPeriod: "Period",
    colBillingStatus: "Billing Status",
    profileTitle: "My Profile",
    profileSubtitle: "Personal settings and security",
    profileRole: "Operator Access",
    profileDisplayName: "Display Name",
    profileNamePlaceholder: "Your name",
    profileSaveName: "Save Name",
    profileNameSuccess: "Name saved",
    profileNameError: "Error saving name",
    profileChangePassword: "Change Password",
    profileNewPassword: "New Password",
    profilePasswordPlaceholder: "At least 6 characters",
    profileConfirmPassword: "Confirm Password",
    profileConfirmPlaceholder: "Repeat password",
    profilePasswordSuccess: "Password changed successfully",
    profilePasswordError: "Error changing password",
    profilePasswordMinLength: "Password must be at least 6 characters",
    profilePasswordMismatch: "Passwords do not match",
    profileAccountDetails: "Account Details",
    profileEmail: "Email",
    profileCreatedAt: "Account created",
    profileLastLogin: "Last sign in",
    createTitle: "Add Business",
    createSubtitle: "Onboard a new craft business",
    createSubmit: "Add Business",
    createSuccess: "Craft business created",
    createError: "Error creating",
    createRequiredFields: "Fill required fields (Company, Contact, Email)",
    createLoginEmailRequired: "Provide login email for portal access",
    setMollieTitle: "Mollie Payment Integration",
    setMollieDesc: "API key and profile ID for the Mollie payment integration. These values are stored securely in the database and used by all backend functions.",
    setMollieApiKey: "Mollie API Key",
    setMollieKeyHint: "Test key starts with test_, live key with live_",
    setMollieProfileId: "Mollie Profile ID",
    setMollieProfileHint: "Used for multi-company isolation (security check)",
    setMollieSave: "Save",
    setMollieSaving: "Saving…",
    setMollieSaved: "Mollie settings saved",
    setMollieTestBtn: "Test Connection",
    setMollieTesting: "Testing…",
    setMollieTestFail: "Connection failed",
    setMollieDiag: "Mollie Diagnostics",
  },
  mollieDiag: {
    allPassed: "All checks passed",
    warningsFound: "Warnings found",
    errorsFound: "Errors detected",
    summaryPassed: "{{passed}}/{{total}} passed · {{warnings}} warnings · {{failed}} failures",
    refresh: "Refresh",
    simulateWebhook: "Simulate Webhook",
    webhookSimulated: "Webhook simulated: {{id}}",
    reconcilePending: "Reconcile Pending",
    reconciled: "{{reconciled}} of {{total}} reconciled",
    auditExport: "Export Audit Log",
    auditExported: "{{count}} entries exported",
    stateMachineTitle: "State Machine – Billing & Mandate",
    providerBillingStatus: "Provider Billing Status",
    paymentSetupStatus: "Payment Setup Status",
    webhookProcessing: "Webhook Processing",
    lastCheck: "Last check:",
    secrets: "Secrets & Configuration",
    mollieConnectivity: "Mollie API Connection",
    profileIsolation: "Multi-Company Isolation",
    webhooks: "Webhook Events (last 20)",
    providerPayments: "Provider Payment Methods",
    subscriptions: "Subscriptions",
    billingCurrentMonth: "Billing Current Month",
    securityEvents: "Security Events",
    deliveryGuards: "Delivery Guards",
    notAuthenticated: "Not authenticated",
    requestFailed: "Request failed",
  },
  avatarPicker: {
    changeAvatar: "Change Avatar",
    selectAvatar: "Select Avatar",
    uploadImage: "Upload Image",
    dragOrClick: "Select or drag an image here",
    maxSize: "Max. 2 MB · JPG, PNG, WebP",
    uploading: "Uploading...",
    onlyImages: "Only image files allowed",
    maxFileSize: "Maximum file size: 2 MB",
    uploaded: "Avatar uploaded",
    uploadFailed: "Upload failed",
    saved: "Avatar saved",
    saveFailed: "Error saving",
  },
  emailEditor: {
    subject: "Subject",
    content: "Content",
    preview: "Preview",
    availablePlaceholders: "Available Placeholders",
  },
  regDetail: {
    legalName: "Legal Name",
    phone: "Phone",
    website: "Website",
    invoiceEmail: "Invoice Email",
    address: "Address",
    vatId: "VAT ID",
    mainRegion: "Main Region",
    categories: "Categories",
    serviceRegions: "Service Regions",
    sla: "SLA",
    weeklyLimit: "Weekly Limit",
    remote: "Remote",
    reviewerNotes: "Internal Notes",
    additionalContacts: "Additional Contacts",
    approveBtn: "Approve & Create Account",
    approving: "Approving...",
    rejectBtn: "Reject",
    approvedMsg: "Approved – Provider account was created",
    statusPending: "Pending",
    statusApproved: "Approved",
    statusRejected: "Rejected",
  },
  opHeader: {
    clockSuffix: "",
  },
  aiSearch: {
    title: "What is CRAFTFINDUS?",
    definition: "CRAFTFINDUS is a digital quality platform for matching verified craft businesses in Germany, Austria, Switzerland, the Netherlands, Belgium, France and Poland. Clients describe their project – CRAFTFINDUS uses intelligent matching to find 3 to 5 suitable, verified craft businesses in their region. The service is free and non-binding for clients. Craft businesses pay a transparent fixed price per accepted contact – no commissions, no contract commitment.",
    highlight1: "Verified businesses: trade registration, insurance, creditworthiness checked",
    highlight2: "Max. 3–5 businesses per project: fair chances, no price war",
    highlight3: "Transparent pricing: fixed contact prices, no hidden fees",
    highlight4: "Fair complaints process: refund for unqualified contacts",
  },
  seoLanding: {
    verified: "Verified businesses",
    free: "Free & non-binding",
    fast: "Response in 24h",
    ctaRequest: "Submit inquiry now",
    freeForClients: "Free for clients",
    whatIsCraftfindus: "What is CRAFTFINDUS?",
    whatIsCraftfindusText: "CRAFTFINDUS is a digital platform connecting clients with verified craft businesses in Germany, Austria, Switzerland, Belgium, the Netherlands, France and Poland. You describe your project – we find 3 to 5 matching businesses in your area. Free and non-binding for clients.",
    verifiedProviders: "Verified {{trade}} in {{city}}",
    howItWorks: "How CRAFTFINDUS works",
    costs: "{{trade}} costs & prices",
    inCity: "in {{city}}",
    faq: "Frequently asked questions",
    ctaHeading: "Looking for {{trade}} in {{city}}?",
    ctaSubtext: "Submit your free inquiry now and receive up to 5 quotes from verified businesses.",
    relatedCities: "{{trade}} in other cities",
    otherTrades: "Other trades in {{city}}",
    relatedArticles: "Related guides",
  },
  blog: {
    title: "CRAFTFINDUS Guide",
    description: "Tips, costs and guides for craft projects",
    noPosts: "No posts yet.",
    backToList: "Back to guide",
  },
  warum: {
    seoTitle: "Why CRAFTFINDUS – The quality platform for craft matching",
    seoDesc: "Learn why CRAFTFINDUS is different: lead quality checks, transparent pricing, verified businesses and a fair reclamation process.",
    heroLabel: "Why CRAFTFINDUS",
    heroTitle1: "Craft matching,",
    heroTitle2: "as it should be.",
    heroDesc: "Most platforms distribute contacts. We match qualified projects with verified businesses – fair, transparent and outcome-optimised.",
    problemLabel: "The market problem",
    problemTitle: "What goes wrong on other platforms",
    problem1Title: "Unqualified inquiries",
    problem1Desc: "Contacts without budgets, without real projects, without verified data. You pay for leads that never become orders.",
    problem2Title: "Opaque costs",
    problem2Desc: "Hidden fees, commissions on orders, unclear pricing models. You never know exactly what you actually pay.",
    problem3Title: "Mass distribution",
    problem3Desc: "Your inquiry goes to 10, 15 or 20 businesses at once. The result: price wars, copy-paste quotes, frustration.",
    problem4Title: "No right to complain",
    problem4Desc: "Contact unreachable? Wrong trade? Tough luck. On most platforms, there's no fair solution.",
    solutionLabel: "Our approach",
    solutionTitle: "What CRAFTFINDUS does differently",
    solution1Title: "Lead quality score",
    solution1Desc: "Every inquiry is automatically scored: phone verified, budget provided, description present. Only inquiries with a score > 60 are billed.",
    solution2Title: "Transparent contact prices",
    solution2Desc: "Fixed prices per contact – visible in advance. No commissions, no hidden fees. You always know what you pay.",
    solution3Title: "Max. 3-5 businesses per project",
    solution3Desc: "Every inquiry goes to a maximum of 5 verified businesses. Less competition, higher closing rates, fair chances.",
    solution4Title: "Fair reclamation process",
    solution4Desc: "Contact unreachable? Wrong trade? You get your contact price back – within 72 hours, guaranteed.",
    solution5Title: "Verified businesses",
    solution5Desc: "Trade licence, insurance, creditworthiness – our businesses undergo a multi-step verification process.",
    solution6Title: "Fairness mechanism",
    solution6Desc: "Automatic abuse detection, transparency dashboard and maximum complaint rates protect platform quality.",
    ctaTitle: "Convinced?",
    ctaClientBtn: "Start your project professionally",
    ctaProviderBtn: "Secure more qualified projects",
  },
  inquiryPsych: {
    qualityHint: "The more accurate your details, the better the businesses you receive.",
    timePromise: "Takes less than 2 minutes",
    matchingHint: "We review your inquiry before forwarding it to matching businesses.",
    descShort: "Please describe your project in more detail.",
    descGood: "Excellent description – this increases your chances of quick quotes.",
    photoHint: "Photos help with an accurate assessment.",
  },
  quality: {
    seoTitle: "Quality promise – How CRAFTFINDUS works",
    seoDesc: "Learn transparently how we verify projects, check businesses, bill fairly and handle reclamations.",
    heroLabel: "Our quality promise",
    heroTitle1: "Transparency.",
    heroTitle2: "Not just a promise.",
    heroDesc: "We explain exactly how our platform works – from project verification to reclamation.",
    sec1Title: "How projects are verified",
    sec1Desc: "Every inquiry goes through our automatic quality engine. Only inquiries scoring at least 60 points are forwarded to businesses.",
    sec1Item1: "Phone number verified (+20 points)",
    sec1Item2: "Budget provided (+25 points)",
    sec1Item3: "Project description checked (+10 points)",
    sec1Item4: "Contact details complete (+10 points)",
    sec2Title: "How businesses are verified",
    sec2Desc: "Our businesses undergo a multi-step verification process. Only verified businesses receive project inquiries.",
    sec2Item1: "Trade licence verified (Level 1)",
    sec2Item2: "Liability insurance verified (Level 2)",
    sec2Item3: "Credit check passed (Level 3)",
    sec2Item4: "Identity verification completed (Level 3)",
    sec3Title: "How billing works",
    sec3Desc: "Transparent, predictable costs. No hidden fees, no commissions on orders.",
    sec3Item1: "Fixed prices per contact – visible in advance",
    sec3Item2: "Flexible models: Flex, Professional, Premium",
    sec3Item3: "Monthly billing, cancel anytime",
    sec4Title: "How reclamation works",
    sec4Desc: "Fair process for legitimate complaints. Refund within 72 hours.",
    sec4Item1: "Submit reclamation directly in the dashboard",
    sec4Item2: "Reasons: Unreachable, wrong trade, not a real project",
    sec4Item3: "Legitimate reclamations are refunded immediately",
    ctaTitle: "Still have questions?",
    ctaDesc: "Contact us or get started – we stand for transparency and fairness.",
    ctaClientBtn: "Start your project professionally",
    ctaProviderBtn: "Secure more qualified projects",
  },
};

export default en;
